module.exports = __webpack_public_path__ + "8828005e78777dab61c0038d5a398d95.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-11.png
// module id = 2058
// module chunks = 0